module.exports = __webpack_public_path__ + "static/media/yearlyplan.48301d39.png";